export const mergePageSelection = (
  previous: Set<number>,
  currentPageIds: number[],
  selectedPageIds: number[],
): Set<number> => {
  const next = new Set(previous);
  currentPageIds.forEach((id) => next.delete(id));
  selectedPageIds.forEach((id) => next.add(id));
  return next;
};

export const removeSelectedIds = (
  previous: Set<number>,
  removedIds: Iterable<number>,
): Set<number> => {
  const next = new Set(previous);
  for (const id of removedIds) next.delete(id);
  return next;
};

export const getCartesianTargetCount = (
  customerCount: number,
  productCount: number,
): number => customerCount * productCount;
